import { Box, Table, TableCell, TableHead, TableRow } from "@mui/material";
import { useEffect } from "react";
import { useQuery } from "react-query";
import AlertApi from "../../../../services/API/Alert.Api";

const AspenAlerts = (props: any) => {
  const { SetAspenAlerts } = props;

  // Get Aspen Alerts:
  const { data: aspenAlertData } = useQuery(
    ["GetAspenAlerts"],
    () => AlertApi.getAspenAlerts(),
    {
      initialData: [],
      refetchInterval: 1000 * 60 * 1, //1 min
      refetchIntervalInBackground: true,
    }
  );

  useEffect(() => {
    SetAspenAlerts(aspenAlertData.length);
  }, [aspenAlertData]);

  return (
    <Box
      style={{ display: "table", marginTop: "20px", minWidth: "100%" }}
      alignItems="center"
    >
      <fieldset
        style={{
          fontSize: "large",
          fontWeight: "bold",
          border: "1px solid silver",
        }}
      >
        <legend>&nbsp;Aspen Alerts&nbsp;</legend>
        <Table
          sx={{ minWidth: 650 }}
          aria-label="simple table"
          className={"myTable"}
        >
          <TableHead>
            <TableRow>
              <TableCell>Url</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Response Time</TableCell>
            </TableRow>
          </TableHead>
          {aspenAlertData.length > 0 ? (
            aspenAlertData.map((row: any, index: any) => {
              return (
                <TableRow
                  hover
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  role="checkbox"
                >
                  <TableCell>{row.url}</TableCell>
                  <TableCell>{row.status}</TableCell>
                  <TableCell>{row.responseTime}</TableCell>
                </TableRow>
              );
            })
          ) : (
            <TableRow
              hover
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              role="checkbox"
            >
              <TableCell
                align="center"
                colSpan={3}
                style={{
                  fontSize: "18pt",
                  fontWeight: "bold",
                }}
              >
                No Record Found
              </TableCell>
            </TableRow>
          )}
        </Table>
      </fieldset>
    </Box>
  );
};

export default AspenAlerts;
